exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-6a155c2c]{font-family:Verdana,Arial;margin:5px}", ""]);

// exports
